import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

// Combine les classes CSS avec clsx et tailwind-merge
export function cn(...inputs) {
  return twMerge(clsx(inputs))
} 